const vTooltip = {
    mounted(el, binding) {
        init(el, binding);
    },
    updated(el, binding) {
        init(el, binding);
    }
};

function init(el, binding) {
    let position = binding.arg || "bottom";
    let tooltipText = binding.value || "";
    el.setAttribute("position", position);
    el.setAttribute("tooltip", tooltipText);
}

export default vTooltip;
